import React from "react";

const AnswersContext = React.createContext({
  answers: {},
  getAnswer: () => {},
  onAnswerChange: () => {},
  resetAnswers: () => {},
});

export default AnswersContext;
